define.alias("shared/components/shared/configurable-address-fields", "media/components/shared/configurable-address-fields");